// i18n area 'common' — locale lv-LV (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/common.lv-LV.meta.json.
import type { enUS } from './common'

export const lvLV: typeof enUS = {
  nav: {
    home: 'Sākums',
    vms: 'Virtuālās mašīnas',
    templates: 'Template',
    importVms: 'Importēt VM',
    containers: 'Konteineri',
    containersApps: 'Lietotnes',
    containersPods: 'Podi',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI attēli',
    containersOciRegistries: 'OCI registry',
    containersCtTemplates: 'CT template',
    networkServices: 'Tīkla pakalpojumi',
    firewall: 'Ugunsmūris',
    checkpoints: 'Checkpoint',
    backup: 'Backup',
    monitoring: 'Uzraudzība',
    cluster: 'Klasteris',
    clusterSettings: 'Globālie iestatījumi',
    clusterNodes: 'Mezgli',
    clusterDevices: 'USB un PCIe resursi',
    clusterFederation: 'Federācija',
    network: 'Tīkls',
    overlayNetworks: 'Overlay tīkli',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Dati',
    storages: 'Storage',
    hci: 'Hiperkonverģence',
    ceph: 'Ceph',
    system: 'Sistēma',
    tasks: 'Task',
    events: 'Notikumi',
    audit: 'Audits',
    diagnostics: 'Diagnostika',
    notifications: 'Paziņojumi',
    proximity: 'TVirt Proximity',
    users: 'Lietotāji un grupas',
    groups: 'Grupas',
    mfa: 'MFA',
    realms: 'Realm un SSO',
    rbac: 'Lomas un atļaujas',
    credentials: 'Akreditācijas dati',
    scopes: 'Scope',
    tags: 'Tagi',
    explorer: 'Pārlūkot',
    licensing: 'Licence',
    information: 'Informācija'
  },
  mode: {
    light: 'Gaišs',
    dark: 'Tumšs',
    system: 'Sistēmas',
    tooltip: 'Motīvs'
  },
  language: {
    tooltip: 'Valoda'
  },
  langRegion: {
    europe: 'Eiropa',
    northAmerica: 'Ziemeļamerika',
    southAmerica: 'Dienvidamerika',
    asia: 'Āzija'
  },
  notFound: {
    title: 'Lapa nav atrasta',
    body: 'Šī adrese neatbilst nevienai TVirt lapai — tā varēja pārvietoties līdz ar atjauninājumu, vai arī saite ir novecojusi.',
    backHome: 'Atpakaļ uz sākumu'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Viss klasteris',
    noChildren: 'Šeit nav neviena apakšscope',
    recursive: 'Iekļaut pakārtotos',
    collapse: 'Sakļaut scope paneli',
    openPicker: 'Pārlūkot scope',
    up: 'Vienu līmeni augšup',
    countTooltip: '{direct} šajā scope · {total} ar pakārtotajiem'
  },
  search: {
    tooltip: 'Meklēt (⌘K)',
    placeholder: 'Meklēt VM, tīklus, storage…',
    empty: 'Nav rezultātu',
    groups: {
      recent: 'Nesenie',
      shortcuts: 'Saīsnes',
      actions: 'Darbības',
      goTo: 'Doties uz'
    },
    kind: {
      catalog: 'Katalogs',
      scope: 'Scope',
      node: 'Mezgls'
    },
    footer: {
      navigate: 'pārvietoties',
      open: 'atvērt',
      close: 'aizvērt'
    },
    actions: {
      createVm: 'Izveidot VM…',
      uploadIso: 'Augšupielādēt ISO…',
      clusterSettings: 'Klastera iestatījumi',
      consoleOf: 'Doties uz {name} konsoli'
    }
  },
  stub: {
    containersSummary: 'Lietotnes un sistēmas konteineri (CT) ar to OCI attēliem, registry un template — pārvaldīti līdzās jūsu VM.',
    sectionSummary_vms: 'Virtuālās mašīnas un to template — dzīves cikls, snapshot, migrācija un konsoles.',
    sectionSummary_storages: 'Storage, kur mīt VM diski, attēli un metadati.',
    sectionSummary_catalogs: 'Klastera failu artefaktu mājvieta: ISO attēli, CT un VM template un OCI arhīvi, sakārtoti katalogos.',
    sectionSummary_overlay: 'VXLAN overlay tīkli starp klastera mezgliem.',
    sectionSummary_fabric: 'Fiziskā tīkla inventārs — switch, porti, LAGG un loģiskie tīkli.',
    sectionSummary_ipam: 'Adresācija, kas atvasināta no fabric un overlay tīkliem: kurš tur katru adresi.',
    sectionSummary_services: 'DHCP un DNS serveri, atvasināti no tīkla reģistra.',
    sectionSummary_ceph: 'TVirt mezglos pārvaldītie Ceph klasteri.',
    sectionSummary_hci: 'Hiperkonverģentās storage tehnoloģijas TVirt mezglos.',
    sectionSummary_cluster: 'Mezgli, dalība un klastera iestatījumi.',
    containers: 'Sistēmas konteineri ir attīstības plānā — šī sadaļa tos izmitinās.',
    containersApps: 'Konteinerizētās lietotnes ir attīstības plānā — šī zona tās izmitinās.',
    containersPods: 'Podi apvieno konteinerus, kas koplieto tīklu un sējumus — instances ir lietotnes.',
    containersCt: 'Sistēmas konteineri (CT) ir attīstības plānā — šī zona tos izmitinās.',
    multiscsi: 'TVStor MultiSCSI ir attīstības plānā — šī zona to izmitinās.',
    clusterFederation: 'Federācija starp TVirt klasteriem ir attīstības plānā — šī zona to izmitinās.',
    containersOciImages: 'OCI attēli ir attīstības plānā — šī zona tos izmitinās.',
    containersOciRegistries: 'OCI registry ir attīstības plānā — šī zona tos izmitinās.',
    containersCtTemplates: 'CT template ir attīstības plānā — šī zona tos izmitinās.',
    importVms: 'ESXi un Proxmox importētāji nonāks šeit: viesu konvertēšana un masveida migrācija uz TVirt.',
    backup: 'Integrētais backup ienāk ar 6.2: deduplicēti content-addressed repozitoriji, CBT inkrementālās kopijas, nemainīguma logi un repo-to-repo replikācija.',
    monitoring: 'Klastera mēroga resursu sacensības paneļi (cpu.ready, PSI spiediens, iebūvēti brīdinājumi) ir ceļā — šobrīd tie paši rādītāji atrodami katras VM detaļās.'
  },
  home: {
    welcome: 'Esat pieteicies ar kontu: {name}',
    subtitle: 'Šeit ir jūsu TVirt klasteris vienā acu uzmetienā.',
    loadError: 'Neizdevās ielādēt pārskatu — vai TVirt backend ir sasniedzams?',
    health: {
      ok: 'Viss kārtībā',
      warning: 'Nepieciešama uzmanība',
      critical: 'Kritiskas problēmas'
    },
    reason: {
      'node-down': '{subject} ir izslēgts',
      'node-stale': '{subject} kādu laiku nav devis ziņu',
      'node-maintenance': '{subject} ir apkopē',
      'tasks-failed': {
        zero: '{n} neizdevušos task pēdējās 24 h',
        one: '{n} neizdevies task pēdējās 24 h',
        other: '{n} neizdevušies task pēdējās 24 h'
      },
      'storage-degraded': 'storage {subject} ir degradēts',
      'storage-error': 'storage {subject} ir kļūdas stāvoklī',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'klastera store nav sasniedzams',
      'license-absent': 'nav licences — jaunas VM nevar startēt',
      'license-expired': 'licence beigusies — jaunas VM nevar startēt',
      'license-exceeded': 'pārsniegts licences limits — jaunas VM nevar startēt',
      'failover-reserve-eroded': 'failover rezerve gandrīz izsmelta',
      'failover-reserve-exhausted': 'failover rezerve izsmelta — jaunas VM nevar startēt',

      'oci-cache-nearly-full': 'OCI kešatmiņa uz {subject} gandrīz pilna — digestus izmet ar roku',
      'oci-cache-full': 'OCI kešatmiņa uz {subject} pilna — neviens pull neizdosies, kamēr digesti netiks izmesti',
      'config-replica-empty': 'konfigurācijas replika uz {subject} ir TUKŠA — mezglam nav klastera konfigurācijas, līdz izdodas replikācija',
      'config-replica-stalled': 'konfigurācijas replikācija uz {subject} ir apstājusies — lokālā kopija atpaliek no klastera konfigurācijas'
    },
    staleChip: 'Dati nav aktuāli',
    staleAsOf: 'pēdējā replikācija {time}',
    zone: {
      nodes: 'Mezgli',
      failoverReserve: 'Failover rezerve',
      capacity: 'Kapacitāte',
      workload: 'Slodze',
      protection: 'Aizsardzība',
      activity: 'Nesenā aktivitāte'
    },

    // Failover rezerves zona (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Rezerve neskarta',
        eroded: 'Rezerve gandrīz izsmelta',
        exhausted: 'Rezerve izsmelta',
        unknown: 'Rezerve nezināma'
      },
      tolerate: {
        zero: 'pieļauj {n} mezglu zudumu',
        one: 'pieļauj {n} mezgla zudumu',
        other: 'pieļauj {n} mezglu zudumu'
      },
      usedOf: 'izmantoti {used} / {allowed} GiB',
      keepFree: '{n} GiB paturēti brīvi failover vajadzībām',
      expendable: 'no tiem {n} upurējami darbībā',
      headroom: 'vēl var startēt {n} GiB',
      short: 'rezervei trūkst {n} GiB — jaunas VM nevar startēt',
      hp: {
        usedOf: '{size} lapas — lietošanā: {used} / {allowed}',
        keepFree: 'failover vajadzībām paturētas brīvas: {keep}',
        headroom: 'vēl var startēt: {n}',
        short: 'rezervei trūkst: {n} — jaunas VM ar milzu lapām nevar startēt'
      },
      worstCase: 'sliktākais gadījums: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Neviens mezgls vēl nav paziņojis savu atmiņu — rezervi nevar aprēķināt un neviena startēšana netiek atteikta.',
      reason: {
        attestedDown: 'apliecināti izslēgts',
        maintenance: 'apkopē',
        unreachable: 'nesasniedzams',
        capacityUnknown: 'atmiņa nav paziņota'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} kodoli / {threads} pavedieni',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        zero: '{n} aktīvu VM',
        one: '{n} aktīva VM',
        other: '{n} aktīvas VM'
      },
      activeVmsUnknown: 'aktīvās VM nav zināmas',
      lastSeen: 'redzēts {time}',
      neverSeen: 'nekad nav redzēts',
      down: 'Izslēgts',
      maintenance: 'Apkope',
      stale: 'Nesasniedzams'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: 'piešķirti {n} GiB',
      reserve: 'rezerve {n} GiB',
      unobserved: 'kapacitāte vēl nav novērota',
      empty: 'Vēl nav neviena storage'
    },
    workload: {
      vms: 'Virtuālās mašīnas',
      apps: 'Lietotnes',
      services: 'Tīkla pakalpojumi',
      empty: 'Vēl neviena',
      phasesUnknown: 'sadalījums pa fāzēm nav pieejams'
    },
    protection: {
      none: 'Nav konfigurēts neviens dublējumu mērķis — aizsargājiet savu konfigurāciju.',
      configure: 'Konfigurēt checkpoint',
      noRuns: 'Vēl nav izveidots neviens checkpoint.',
      last: 'Pēdējais checkpoint',
      onTarget: 'uz {target}',
      viewAll: 'Checkpoint'
    },
    activity: {
      empty: 'Nav nesenas aktivitātes',
      failed24: {
        zero: '{n} neizdevušos 24 h laikā',
        one: '{n} neizdevies 24 h laikā',
        other: '{n} neizdevušies 24 h laikā'
      },
      viewAll: 'Skatīt visus task'
    }
  },
  notes: {
    title: 'Piezīmes',
    tabEdit: 'Rediģēt',
    tabPreview: 'Priekšskatījums',
    placeholder: 'Operatora brīvās piezīmes — Markdown tiek atveidots priekšskatījumā',
    empty: 'Nav piezīmju',
    tooLarge: 'Piezīmes pārsniedz 64 KiB ierobežojumu',
    saveError: 'Neizdevās saglabāt piezīmes'
  },
  common: {
    contractError: 'Backend atbilde satur vērtību, ko šī saskarne nepazīst: {field}={value} — atjaunini tīmekļa saskarni līdz backend versijai.',
    contractErrorItems: '{count} šī saraksta objektus šī saskarne nevar nolasīt ({field}={value}), un tie netiek rādīti.',
    staleHint: 'Store nav sasniedzams — šī ir šī mezgla konfigurācijas replika; flotes stāvoklis nav zināms.',
    staleStateAge: 'stāvoklis uz {time}',
    staleStateNever: 'stāvoklis nekad nav saņemts no store: redzat tikai šī mezgla novērojumus',
    staleStateTooltip: 'Klastera store nav sasniedzams: novērotais stāvoklis (fāze, mezgls, aģents) nāk no šī mezgla stāvokļa replikas un atbilst pēdējai veiksmīgajai nolasīšanai no store — tas var būt novecojis.',
    noPermission: 'Jums nav atļaujas šai darbībai',
    actionStillRunning: 'Darbība vēl turpinās — iznākums vēl nav zināms',
    staleWrite: 'Kāds cits mainīja šo objektu, kamēr jūs to rediģējāt — nekas netika ierakstīts. Pārlādējiet un atkārtojiet izmaiņas uz aktuālā stāvokļa.',
    staleReload: 'Pārlādēt',
    preview: 'Priekšskatījums',
    previewTitle: 'Rezultāta priekšskatījums',
    previewNothingWritten: 'Simulēts serverī — nekas netika ierakstīts.',
    previewChanged: 'Izceltas vērtības, kas mainītos.'
  },
  context: {
    copySelection: 'Kopēt atlasīto tekstu'
  },
  crud: {
    create: 'Izveidot',
    viewDetails: 'Skatīt detaļas',
    viewOrEdit: 'Skatīt vai rediģēt',
    selected: 'atlasīti',
    viewUsingVms: 'Skatīt VM, kas izmanto šo resursu',
    clearSelection: 'Notīrīt atlasi',
    deleteSelected: 'Dzēst atlasītos',
    bulkConfirmBody: {
      zero: 'Vai dzēst {count} atlasīto elementu? Aizsargātie tiks norādīti un saglabāti.',
      one: 'Vai dzēst {count} atlasīto elementu? Ja tas ir aizsargāts, tas tiks norādīts un saglabāts.',
      other: 'Vai dzēst {count} atlasītos elementus? Aizsargātie tiks norādīti un saglabāti.'
    },
    bulkDeleted: 'dzēsti',
    bulkRefused: 'atteikti',
    fieldId: 'ID',
    createdAt: 'Izveidots',
    updatedAt: 'Atjaunināts',
    immutableField: 'Fiksēts izveides brīdī — contract neļauj to mainīt',
    immutableScope: 'Scope tiek piešķirts izveides brīdī; dažus resursus pārvieto ar īpašu darbību',
    observedField: 'Novērotais stāvoklis — platformas ziņots, nav rediģējams'
  }
}
